import { render, staticRenderFns } from "./AccountActivate.vue?vue&type=template&id=679e0e1d&scoped=true"
import script from "./AccountActivate.vue?vue&type=script&lang=js"
export * from "./AccountActivate.vue?vue&type=script&lang=js"
import style0 from "./AccountActivate.vue?vue&type=style&index=0&id=679e0e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e0e1d",
  null
  
)

export default component.exports